// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"265":"67198ecc","500":"f5c652cb","816":"d347c1ef","829":"4aed71c0"}[chunkId] + ".chunk.css";
};